import { EVENTS } from '../constants/webSocketConsts/events';
import {
  addFileChannelsAction,
  removeFileChannelsAction,
  updateFileChannelsAction,
} from '../store/files/actions';

const ChannelHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return addFileChannelsAction(items);
    case EVENTS.MODIFY:
      return updateFileChannelsAction(items);
    case EVENTS.REMOVE:
      return removeFileChannelsAction(items);
    default:
      break;
  }
  return null;
};

export default ChannelHandler;
